const zhCN = {
  chat: {
    title: "Bambulab 在线客服",
    historyMsg: "以上是历史消息",
    moreHistory: "查看更多历史记录",
    noMoreHistory: "暂无更多历史记录",
    wholeHistory: "以上是历史记录",
    canceledLineUp: "已取消排队",
    cancelLineUp: "取消排队",
    newMessageTips: "{0}条新消息",
    questionListTitle:
      "欢迎使用在线技术支持！请选择您需要帮助的问题类型，我们将会分配对应领域的技术支持，尽快解决您的问题。",
    questionSolved: "您的问题是否得到解决？",
    solved: "已解决",
    unSolved: "未解决",
    satisfyTitle: "麻烦您对本次客服进行评价",
    satisfyPlaceholder:
      "您的意见对我们至关重要，请分享您的评价原因，帮助我们提供更好的服务。",
    withdrawing: "撤回中",
    withdraw: "撤回消息",
    quotedMessage: "引用消息",
    copy: "复制",
    video: "视频",
    image: "图片",
    file: "文件",
    reply: "回复",
    expandText: "展开",
    collapseText: "收起",
    iHaveRedrawMsg: "我已撤回该消息",
    othersHaveRedrawMsg: "对方已撤回该消息",
    quotedHaveRedrawMsg: "引用消息已撤回",
    stopServiceTips:
      "今日人工服务将于${0} 结束，感谢您的耐心等待。您可在次日人工服务时间再次联系，也可提交工单联系我们。",
    AISuspended: "Bambu AI 已停止",
    AIProvided: "此结果由Bambu AI提供，内容仅供参考。",
    isHelpful: "这些信息对您有帮助吗？",
    hasIMSession: "当前已经接入人工客服，您可以直接输入继续会话。",
  },
  aiFeedback: {
    satisfyTitle: "我的回答有没有解决您的问题呢？",
    satisfyPlaceholder:
      "您的意见对我们至关重要，请分享您的评价原因，帮助我们提供更好的服务。",
    satisfyLiked: "感谢您的肯定！我会继续加油的！",
    satisfyDislike: "未解决",
    satisfyLike: "已解决",
    satisfyClose: "关闭",
    satisfySubmit: "提交",
    satisfyCancel: "取消",
    satisfyDislikeOptionLabel: "不满意项",
    satisfyKnowledgeReasonLabel: "原因标识",
    "2000": "没有帮助",
    "2001": "知识过时",
    "2002": "问题理解错误",
    "2003": "事实错误",
    "2004": "回答不准确",
    "2005": "内容有害/不健康",
    "2006": "前后回复不一致",
    "10": "响应时间太长",
    "20": "答案与问题无关",
    "30": "答案不够详细或准确",
    "40": "无法找到答案",
    "50": "Wiki文章不正确",
    "1000": "其他",
    thanksFeedback:
      "感谢您的反馈！我们会继续优化和改进，以提供更好的Bambu AI体验。",
    desc1:
      "Bambu AI 正处于(Beta版)阶段，很抱歉无法回答您的问题；欢迎您提供宝贵的建议，以便我们不断的优化，以提供更优质的服务体验。",
    desc2: "",
    feedbackTypeLabel: "请选择未解决的原因：",
    /** 点踩已提交，仅回显时 Radio 组标题 */
    feedbackTypeLabelReadOnly: "未解决原因：",
    feedbackPlaceholder: "在此处输入您的意见和建议",
    feedbackLabel: "建议",
    submit: "提交",
    thanksAIFeedback:
      "感谢您的反馈！我们会继续优化和改进，以提供更好的Bambu AI体验。",
  },
  aiProtocolModal: {
    title: "欢迎使用拓竹科技机器人！",
    protocolContent: "尊敬的用户：",
    protocolContent1:
      "您与此服务的互动意味着您接受了<1>《使用协议》</1>。我们将按照<3>《隐私政策》</3>确保您的个人信息受到保护。点击“继续”与我们的 拓竹机器人 进行互动。",
    protocolContent2:
      "请在继续之前阅读以下免责声明：由于Bambu AI处于测试阶段，回复可能不完全准确或全面，仅供参考，不代表最终答案。",
    continue: "继续",
    tips: "",
  },
  resetUrlModal: {
    showAgainBtn: "7天内不再显示",
    goNow: "立即前往",
    toCNDesc: "建议您访问国内站点以获得最快的体验",
    toENDesc: "建议您访问国际站点以获得最快的体验",
  },
  systemMsg: {
    title: "在线客服",
    satisfyComment: "您已对本次服务进行满意度评价",
    msgWithDrawn: "消息已撤回",
    msgWithDrawnByOthers: "对方消息已撤回",
    reEditExpired: "已超过重新编辑时效",
    chatEnd: "您已结束本次会话",
    messageLoading: "正在加载数据，请稍后...",
    unknownErrorTips: "网络异常，请重试",
    noUserInfo: "抱歉，无法获取您的用户信息，请重试或联系客服",
    messageEnded: "当前会话已结束",
    messageTimeout: "会话已超时",
    lineUpTimeout: "排队超时",
    dataRecovery: "历史数据加载中，请稍等...",
    refreshPageTips: "加载出错，请刷新页面重试",
    currentTimeNotService: "当前时间段客服不在工作时间",
  },
  button: {
    submit: "提交",
    endMessage: "结束会话",
    confirm: "确定",
    reEdit: "重新编辑",
  },
  chatBox: {
    expendButtonTitle: "快速提问",
    autoCompletePlaceholder: "关键词模糊搜索",
  },
  footerTabBar: {
    generalInquiries: "普通咨询",
    selfService: "自助服务",
    popularTags: "热门标签",
    wikiArticles: "Wiki文章",
    inAppTips: "请在app内打开",
    IMService: "人工服务",
  },
  chatBar: {
    sendButton: "发送",
    inputPlaceholder: "请输入您要咨询的内容",
    confirmEndMessage: "确认结束会话吗？",
    confirmExit: "确认退出登录吗？",
    tips: "提示",
  },
  chatInput: {
    sendButton: "发送",
    inputPlaceholder: "请输入消息内容",
    selectEmoji: "选择表情",
    recentlyUse: "最近使用",
    connecting: "正在链接中，请稍后...",
    networkError: "网络异常...",
    networkLost: "当前会话已断开，点击",
    processError:
      "当前无法联系客服，请通过<a href='${0}' target='_blank'>工单</a>解决",
    resetCreateChat: "重新发起会话",
    // networkLostEndText 中文设置为空，这是一个补充文案
    networkLostEndText: "",
    fileLimitTips: "文件大小不能超过${0}MB",
    sendConfirm: "确定发送吗",
    inputPlaceholderDisabled: "请输入消息内容",
  },
  common: {
    sendError: "发送失败，当前网络异常",
    loading: "加载中...",
    requestTimeout: "请求超时，请刷新重试",
  },
  error: {
    pageError: "抱歉，系统暂时遇到了问题，请稍后再试",
    errorVisible: "出错了",
    reload: "重新加载",
    loginError: "登录失败，请稍后重试",
    loginLoading: "登录中，请稍后...",
  },
  privacyPolicy: {
    title: "欢迎使用在线客服",
    subTitle: "为了保证服务质量，您的请求信息会被记录，我们通过我们的",
    linkName: "隐私政策",
    confirmTips: "确保您的隐私得到保护。",
    readAndConfirm: "我已阅读并同意",
    usePolicy: "使用条款",
    and: "和",
    privatePolicy: "隐私协议",
    enterChat: "进入聊天",
  },
  tips: {
    copySuccess: "复制成功",
    copyFileSuccess: "复制文件链接成功，请在浏览器打开",
  },
  riskMsg: {
    forbidden: "您发的内容为敏感内容，无法发送",
    content: "当前消息为敏感消息",
    copySuccess: "复制成功",
  },
  sidebar: {
    hello: "Hello!",
    desc: "很高兴为您服务",
  },
  header: {
    robotDesc: "客服机器人",
    robot: "拓竹科技",
  },
  carouselImageList: {
    title1: "访问商店",
    boxIssueTitle: "机器问题",
    logisticsIssueTitle: "物流问题",
  },
  categoryList: {
    error: "暂无可用内容",
  },
  issueType: {
    missionItems: {
      templateName: "缺少物品",
      attachmentTips: [
        "请提供订单号和包裹的照片",
        "请提供包裹标签的照片",
        "请提供缺少物品的照片",
      ],
    },
    receivedTheWrongItem: {
      templateName: "收到错误物品",
      attachmentTips: ["请提供收到物品的照片", "请提供收到物品的照片"],
    },
    shippingOrPackaging: {
      templateName: "运输或包装",
      attachmentTips: [
        "请提供包装损坏的照片",
        "请提供产品损坏的照片",
        "请提供快递单号",
      ],
      attachmentTipText: "请提供相关照片",
      children: [
        "打印机损坏",
        "AMS 损坏",
        "配件损坏",
        "包装破损但产品完好",
        "其他",
      ],
    },
    factoryDamage: {
      templateName: "出厂损坏",
      attachmentTips: [
        "请提供产品序列号照片",
        "请提供损坏部位照片",
        "请提供包装完好照片",
      ],
    },
    manufacturingIssue: {
      attachmentTips: [
        "请提供产品序列号照片",
        "请提供问题照片或视频",
        "请详细描述问题",
      ],
    },
    lostPackage: {
      templateName: "包裹丢失",
      childLabelTips: "请选择丢失原因",
      children: ["未收到包裹", "包裹被盗", "快递公司丢失", "其他"],
      attachmentTips: "请提供相关证明",
    },
    noShippingMovementForDays: "多日无物流更新",
    shippedToTheWrongAddress: {
      templateName: "发货至错误地址",
      children: ["地址填写错误", "系统地址错误", "其他"],
    },
    packageWasReturnedToSenderOrCanceled: "包裹被退回或取消",
    carrierServiceComplaint: "快递服务投诉",
    other: "其他",
    testMachineOptions: [
      "否，我还没有测试打印机/AMS",
      "是的，它工作正常",
      "是的，但它出现故障",
    ],
  },
  collectOrderInfo: {
    title: "请提供您的订单号和用于验证的邮箱。",
    orderNumPlaceholder: "请输入",
    emailPlaceholder: "请输入",
    submit: "提交",
    email: "邮箱",
    orderNum: "订单号",
    orderNumMessage: "请输入订单号",
    orderNumMessageTip: "格式为GB/EN/AU/UK/US/CA/JPxxx",
  },
  uDeskTicker: {
    imgFormatError: "您只能上传JPG/PNG文件！",
    imgSizeError: "图片大小必须小于20MB！",
    submit: "提交",
    cancelText: "取消",
    issueType: "问题的原因",
    email: "邮箱",
    emailPlaceholder: "帐户邮箱",
    orderNum: "订单号",
    orderNumPlaceholder: "订单号",
    UploadText: "+ 上传",
    model: "打印机型号（或产品）",
    address: "地址",
    addressOptions: {
      "1": "与订单地址相同",
      "2": "需要更改地址",
    },
    changeAddress: "地址",
    comment: "请提供问题的具体细节。",
    commentTips: "请简要描述您的问题。",
    testMachine: "您是否测试过打印机/AMS？",
    orderNumTips: "（如果不适用，请在订单号前加上＃）",
    orderNumMessage: "请输入订单号",
    informationNotMatch: "信息不匹配，请验证并重试。",
    attachment: "附件",
    other: "其他",
    orderNumMessageTip: "如何获取订单ID?",
    noRecord: "没有记录",
  },
  feedback: {
    reasonOptions: {
      "1": "没有我想了解的问题",
      "2": "答案不够准确",
      "3": "流程太复杂",
      "4": "其他",
    },
    submitReply: "感谢您的反馈！",
    title1:
      "拓竹机器人正在更新迭代中，很抱歉无法回答您的问题；欢迎您提供宝贵的建议，以便我们不断的优化，以提供更优质的服务体验。",
    title2: "",
    feedbackTypePlaceholder: "请选择",
    feedbackTypeLabel: "请选择未解决的原因：",
    feedbackPlaceholder: "在此处输入您的意见和建议",
    feedbackLabel: "建议",
    submit: "提交",
  },
  selectCategory: {
    notFound: "抱歉，我找不到相关的问题和答案，请提交工单以获取进一步帮助。",
    title: "请选择您的问题类型以继续。",
    contactUs: "以上都不适用于我的情况，我想要联系客服。",
    submitTicket: "提交工单",
  },
  selectQuestion: {
    title: "请选择并点击问题，获取问题的答案。",
    contactUs: "以上都不适用于我的情况，我想要联系客服。",
    submitTicket: "提交工单",
    more: "展开",
    less: "收起",
  },
  selectHotAIQuestion: {
    tryAgain: "请稍后再试。",
    replying: "Bambu AI正在生成回复中，请稍后重试。",
    hotTopics: "热门话题",
    AIModeStartTips: "请启动技术 AI 模式",
    hotThinking: "您是否想问以下问题？",
    printerTips: "准备打印时出问题了吗?让我来帮您看看！",
    bindingPrinterTips: (printerModel: string) => {
      return `绑定${printerModel}机型时,您遇到了什么问题呢?`;
    },
    bindingPrinterTipsNoPrinter: "绑定打印机时,您遇到了什么问题呢?",
  },
  firstAIReplyOversea:
    "您可通过以下途径获取人工服务：<ul><li>如有任何产品、订单相关或综合咨询，您可以通过<a class='message-link' href='/im?from=2' target='_blank'>在线客服（24/7）</a>联系我们。</li><li>如有任何配件/耗材问题、运输/配送问题，请提交<a class='message-link' href='https://bambulab.com/zh/my/support/general-inquiry?from=2' target='_blank'>综合工单</a></li><li>如有任何打印机/AMS 性能问题，请提交 <a class='message-link' href='https://bambulab.com/zh/my/support/tickets/create?from=2' target='_blank'>技术工单</a>，确保获得更专业的支持</li><li>如有任何与 MakerWorld 相关的问题，请提交<a class='message-link' href='https://makerworld.com/zh/my/support/tickets/create?from=2' target='_blank'> MakerWorld 工单</a></li></ul>",
  firstAIReply:
    "如需进一步帮助，您可通过以下途径获取人工服务💁：<ul><li>产品咨询、订单及发票问题，请联系拓竹（<a class='message-link' href='https://mall.jd.com/index-12045041.html' target='_blank'>京东</a>丨<a class='message-link' href='https://bambulab.tmall.com/' target='_blank'>天猫</a>丨拼多多丨抖音）官方旗舰店客服。</li><li>打印机、软件等技术问题，请联系 <a class='message-link' href='https://support.bambulab.cn/cn/im?from=2' target='_blank'>在线技术支持</a> （9:00–21:00；法定节假日 9:00–18:00）。</li><li>提交 <a class='message-link' href='https://bambulab.cn/zh-cn/my/support/tickets/create?from=2' target='_blank'>技术咨询工单</a>获取进一步技术分析与支持。</li><li>产品使用、投诉与建议，请拨打服务热线 <b>400 680 0166</b> （周一至周日 9:00–12:30，14:00–18:00）。</li><li>模型社区相关问题，请提交 <a class='message-link' href='https://makerworld.com.cn/zh/my/support/tickets/create?from=2' target='_blank'>MakerWorld服务工单</a>。</li></ul>",
};

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type LocaleType = typeof zhCN;
export type PartialLocaleType = DeepPartial<typeof zhCN>;

export default zhCN;
